import _BaseController from 'Controllers/Web/_BaseController';
import ListControllerVue from 'Vue/Web/Common/Clinic/ListController.vue';

global.Controller = new (class extends _BaseController {
    ListControllerVue?: Vue;

    ready() {
        super.ready();

        this.ListControllerVue = new Vue({
            ...ListControllerVue,
            el: '.wrap',
            propsData: {},
        });
    }
})();
